import moment from 'moment';
import { CATEGORIE_UNITAIRE } from '@/configuration/catalogue/produitConf';

export default function dateRenouvellementGenerator(commande) {
  if (!commande.renouvelable) return;
  const ligneCommandeProduitAvecDate = commande.lignesCommande
    .filter(l => l.typeProduit === CATEGORIE_UNITAIRE);
  if (ligneCommandeProduitAvecDate.length) {
    const datesFin = ligneCommandeProduitAvecDate.map(l => moment(l.dateFin));
    const dateFin = new Date(Math.max.apply(null, datesFin));
    commande.dateRenouvellement = dateFin;
  }
}
